<template>
    <BaseModal name="regionsContractsModal" width="560" :clickToClose="false" :shiftY="0.5"
        @before-close="beforeCloseRegionsModal" @before-open="openModal" :adaptive="true" height="430"
        classes="bg-transparent shadow-none">
        <div
            class="modal-base-content modal-content py-20 h-100 px-30 rounded-25 bg-white position-relative overflow-hidden">
            <BaseLoader v-if="localLoading"></BaseLoader>
            <div class="d-flex justify-content-end">
                <slot name="modal-header"></slot>
                <button type="button" class="btn-close" @click="$modal.hide('regionsContractsModal')"></button>
            </div>
            <div
                class="modal-content-dynamic flex-grow-1 d-flex flex-column h-100 align-items-center justify-content-center">
                <p class="fw-bold text-center mb-0">
                    {{ dataLang['reg_contract_edit_29'] }}
                </p>
                <div class="text-center mb-15">{{ dataLang['reg_contract_modal_111'] }}</div>
                <div class="d-flex gap-5 mb-15">
                    <BaseSelect style="width: 323px" placeholder="" :showNoOptions="false" :showNoResults="false"
                        selectLabel="" deselectLabel="" @input="" v-model="selectedRegion" label="regions__name"
                        :options="selectListRegion" :maxHeight="200">
                    </BaseSelect>
                    <div class="bg-opposite cursor-pointer rounded-5 d-flex" style="width: 26px; height: 26px;"
                        @click="addContractRegion">
                        <img :src="require(`@/assets/icons/add.svg`)" class="m-auto" width="10" height="10" />
                    </div>
                </div>
                <div class="d-flex gap-10 flex-wrap wp-100">
                    <div class="py-5 px-15 d-flex gap-15 fsc-11 align-items-center border border-muted"
                        style="height: min-content;" v-for="item of selectedListRegions"
                        :key="item.contract_regions__region_id">
                        {{ item.regions__name }}
                        <svg width="10" class="cursor-pointer" @click="() => deleteRegion(item.contract_regions__id)"
                            height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1.11088 0.403801C0.915615 0.208539 0.599033 0.208539 0.403771 0.403801C0.208509 0.599064 0.208509 0.915646 0.403771 1.11091L4.29286 5L0.403771 8.88908C0.208509 9.08435 0.208509 9.40093 0.403771 9.59619C0.599034 9.79145 0.915616 9.79145 1.11088 9.59619L4.99997 5.7071L8.88899 9.59613C9.08426 9.79139 9.40084 9.79139 9.5961 9.59613C9.79136 9.40087 9.79136 9.08429 9.5961 8.88902L5.70707 5L9.59616 1.11091C9.79142 0.915646 9.79142 0.599064 9.59616 0.403801C9.4009 0.208539 9.08432 0.208539 8.88905 0.403801L4.99997 4.29289L1.11088 0.403801Z"
                                fill="black" />
                        </svg>
                    </div>
                </div>
                <div class="d-flex justify-content-end gap-30 mt-30">
                    <div @click="$modal.hide('regionsContractsModal')"
                        class="btn btn-sm py-5 btn-opposite px-15 rounded-5 d-flex align-items-center justify-content-center text-uppercase">
                        {{ dataLang['register_academy_text_18'] }}
                    </div>
                </div>
            </div>
        </div>
    </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import GeneralService from '@/api/GeneralService.js'
import EventBus from '@/event-bus'

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
    components: {
    },
    data() {
        return {
            localLoading: false,
            dataForModal: {},
            contractId: null,
            selectedRegion: {},
            selectListRegion: [],
            selectedListRegions: []
        }
    },
    methods: {
        openModal(openedParams) {
            this.localLoading = true
            this.contractId = openedParams.params.contracts__id
            Promise.all([
                GeneralService.get(`/regions`)
                    .then((data) => {
                        console.log(data);
                        this.selectListRegion = data.data.data.rows
                    })
                    .catch((e) => {
                        console.error(e)
                        if (e?.response?.data?.message) {
                            this.$toast.error(e?.response?.data?.message, { duration: 5000 })
                        }
                    }),
                this.getListSavedRegions()
            ]).then((data) => {
                this.localLoading = false
            })
        },
        async getListSavedRegions() {
            return GeneralService.get(`/contracts/${this.contractId}/regions`)
                .then((data) => {
                    this.selectedListRegions = data.data.data.rows
                    this.selectedRegion = {}

                })
                .catch((e) => {
                    console.error(e)
                    if (e?.response?.data?.message) {
                        this.$toast.error(e?.response?.data?.message, { duration: 5000 })
                    }
                })
        },
        beforeCloseRegionsModal() {
            this.selectedRegion = {}
            this.$emit('update')
        },
        addContractRegion() {
            if (this.selectedRegion?.regions__id) {
                this.localLoading = true
                GeneralService.editOrCreate(`/contracts/${this.contractId}/regions`, {
                    regions__id: this.selectedRegion.regions__id
                })
                    .then(async (data) => {
                        this.selectedRegion = {}
                        await this.getListSavedRegions()
                    })
                    .catch((e) => {
                        console.error(e)
                        if (e?.response?.data?.message) {
                            this.$toast.error(e?.response?.data?.message, { duration: 5000 })
                        }
                    }).finally(() => {
                        this.localLoading = false
                    })
            } else {
                this.$toast.error('Выберите регион для добавления', { duration: 5000 })
            }
        },
        deleteRegion(regionId) {
            this.localLoading = true
            GeneralService.delete(`/contracts/${this.contractId}/regions/${regionId}`)
                .then(async (data) => {
                    await this.getListSavedRegions()
                })
                .catch((e) => {
                    console.error(e)
                    if (e?.response?.data?.message) {
                        this.$toast.error(e?.response?.data?.message, { duration: 5000 })
                    }
                }).finally(() => {
                    this.localLoading = false
                })
        }
    },
    mounted() { },
    created() { },
    beforeDestroy() { },

    computed: {
        ...mapState('translationModule', ['dataLang'])
    }
}
</script>
